const tabbedProductCards = (id) => ({
  collectionId: null,
  tabId: null,
  collectionTabs: null,
  sliderInitialized: false,
  init() {
    this.collectionId = id
    this.tabId = id
    this.collectionTabs = this.$refs.tabsSection.querySelectorAll("[data-collection]")
    this.$nextTick(()=>{
      if (this.sliderInitialized){
        this.showHideTab(this.tabId, false)
      }
    })
  },
  switchTab(tabId) {
    this.tabId = tabId
    this.showHideTab(tabId, true)
  },
  showHideTab(tabId, clicked){
    if (this.collectionTabs){
      this.collectionTabs.forEach(tab => {
        tab.classList.remove("active")
        this.collectionId = tab.getAttribute("data-collection-id")

        if (clicked){
          tab.querySelectorAll(".swiper-slide").forEach((slide, index) => {
            slide.classList.remove("animated-slide")
          })
        }

        if (this.collectionId && this.collectionId == tabId){
          tab.classList.add("active")
          tab.querySelectorAll(".swiper-slide").forEach((slide, index) => {
            setTimeout(()=>{
              slide.classList.add("animated-slide")
            }, index * 200)
          })
        }
      })
    }
  }
})

export default tabbedProductCards

window.addEventListener("alpine:init", () => {
  Alpine.data("tabbedProductCards", tabbedProductCards)
})
